import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

const {
  text: { bgColorSecondaryText, bgColorText },
  pressable: { bgColor: bgButtonColor,
    gradientColor: { gradientOne, gradientTwo }, pressedGradientColor, bgIconButton },
  customButtons: { bgBorderColor }
} = primaryColor

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig
export const Button: ComponentStyleConfig = {
  // The styles all button have in common
  baseStyle: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  // Two sizes: sm and md
  sizes: {
    sm: {
      fontSize: 'sm',
      px: 4, // <-- px is short for paddingLeft and paddingRight
      py: 3, // <-- py is short for paddingTop and paddingBottom
    },
    md: {
      fontSize: 'md',
      px: 6, // <-- these values are tokens from the design system
      py: 4, // <-- these values are tokens from the design system
    },
  },
  // Two variants: outline and solid
  variants: {
    secondary: props => ({
      ...baseTheme.components.Button.variants.outline(props),
      rounded: 'full',
      color: bgColorText,
      height: 'fit-content',
      borderRadius: 40,
      paddingX: 4,
      paddingY: 2,
      _disabled: {
        border: '0px',
        _active: {
          color: bgColorText, // ask if remove or no
        }
      },
      _hover: {
        borderColor: 'white',
        bg: 'transparent'
      },
      _active: {
        color: bgColorSecondaryText,
        borderColor: bgButtonColor,
        bgGradient: `linear(to-br, ${gradientOne}, ${gradientTwo})`,
      }
    }),
    primary: props => ({
      ...baseTheme.components.Button.variants.solid(props),
      rounded: 'full',
      color: bgColorSecondaryText,
      borderColor: bgButtonColor,
      height: 'fit-content',
      borderRadius: 40,
      paddingX: 4,
      paddingY: 2,
      bgGradient: `linear(to-br, ${gradientOne}, ${gradientTwo})`,
      _hover: {
        bgGradient: `linear(to-br, ${pressedGradientColor.gradientOne}, ${pressedGradientColor.gradientTwo})`
      },
      _active: {
        bgGradient: `linear(to-br, ${pressedGradientColor.gradientOne}, ${pressedGradientColor.gradientTwo})`
      },
      _disabled: {
        ...baseTheme.components.Button.variants.ghost(props),
        bg: 'transparent',
        _hover: {
          bg: 'transparent'
        },
      },
    }),
    box: props => ({
      ...baseTheme.components.Button.variants.outline(props),
      borderRadius: 15,
      borderColor: bgBorderColor,
      color: bgBorderColor,
      textTransform: 'none',
      height: 120,
      width: 120,
      borderWidth: 2,
      padding: 2,
      _disabled: {
        border: '0px',
        color: bgBorderColor,
        _hover: {
          color: bgBorderColor, // ask if remove or no
        }
      },
      _hover: {
        bgGradient: `linear(to-br, ${pressedGradientColor.gradientOne}, ${pressedGradientColor.gradientTwo})`,
        color: bgIconButton,
      },
      _active: {
        bgGradient: `linear(to-br, ${pressedGradientColor.gradientOne}, ${pressedGradientColor.gradientTwo})`,
        color: bgIconButton,
      },
    }),
    icon: props => ({
      ...baseTheme.components.Button.variants.solid(props),
      rounded: 'full',
      bg: bgIconButton,
      color: 'white',
      _hover: {
        bgGradient: `linear(to-br, ${pressedGradientColor.gradientOne}, ${pressedGradientColor.gradientTwo})`,
        color: bgIconButton
      },
      _active: {
        bgGradient: `linear(to-br, ${pressedGradientColor.gradientOne}, ${pressedGradientColor.gradientTwo})`
      },
      _disabled: {
        ...baseTheme.components.Button.variants.ghost(props),
        bg: 'transparent',
        _hover: {
          bg: 'transparent'
        },
      },
    }),
    link: props => ({
      ...baseTheme.components.Button.variants.link(props),
      color: 'white',
      textTransform: 'none',
    }),
  },
  // The default size and variant values
  defaultProps: {
    size: 'md',
    variant: 'primary'
  },
}
